import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { point, distance } from '@turf/turf';

import { updateRadarVisibility, updateDisplayRecenterPin, searchByPin, updateAddressObj } from '../../../../../../../reducers/_Pages/Public/radarSlice';

const RecenterPin = () => {
  const { map, addressObj, radius, radarVisibility, displayRecenterPin } = useSelector((state) => state.radar);
  const dispatch = useDispatch();
  
  useEffect(() => {
    if (!addressObj.lat || !radarVisibility) return;

    map.current.on('move', () => {
      const center = map.current.getCenter();
      const centerCoords = [center.lng, center.lat];
      const pointCoords = [addressObj.lng, addressObj.lat];

      const from = point(centerCoords);
      const to = point(pointCoords);

      const distanceInMeters = distance(from, to, { units: 'meters' });

      dispatch(updateRadarVisibility(distanceInMeters < (radius*0.8)));
    });
  }, [addressObj, radius]);

  useEffect(() => {
    if (radarVisibility !== displayRecenterPin) return;

    dispatch(updateDisplayRecenterPin(!radarVisibility));
  }, [radarVisibility]);

  const handleCoordinatesUpdate = () => { 
    if (!displayRecenterPin) return;

    const center = map.current.getCenter();
    const geocoder = new google.maps.Geocoder();
    
    geocoder.geocode({ location: center }, (results, status) => {
      if (status === 'OK' && results[0]) {
        dispatch(updateAddressObj({
          ...extractAddress(results[0]),
          lat: center.lat,
          lng: center.lng
        })); 
      }
    });

    dispatch(searchByPin());
  }

  const extractAddress = (place) => {
    const addressComponents = place.address_components
    const addressInfos = {
      'address': place.formatted_address,
      street_number: addressComponents.find(t => t.types[0].includes('street_number'))?.long_name,
      street_name: addressComponents.find(t => t.types[0].includes('route'))?.long_name,
      city: addressComponents.find(t => t.types[0].includes('locality'))?.long_name,
      zip_code: addressComponents.find(t => t.types[0].includes('postal_code'))?.long_name,
      country_code: addressComponents.find(t => t.types[0].includes('country'))?.short_name,
      lat: place.geometry.location.lat,
      lng: place.geometry.location.lng
    }

    return addressInfos;
  }

  return (
    <div className={`absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none transition-opacity ${displayRecenterPin ? 'opacity-100 cursor-pointer' : 'opacity-0 pointer-events-none'}`}>
      <div className='relative flex items-center justify-center'>
        <div className='relative w-3 h-3'>
          <div className='absolute inset-0 rounded-full bg-ih-blue animate-pulse'></div>
          <div className='relative w-3 h-3 rounded-full bg-ih-blue opacity-50 animate-ping'></div>
        </div>

        <p
          className={`absolute bottom-8 ${displayRecenterPin ? 'pointer-events-auto' : 'pointer-events-none'} bg-ih-blue/80 hover:bg-ih-blue bg-opacity-30 px-3 py-2 rounded-xl whitespace-nowrap w-fit text-center text-white text-sm font-semibold backdrop-blur-sm`}
          onClick={() => handleCoordinatesUpdate()}
        >
          Rechercher dans cette zone
        </p>
      </div>
    </div>
  )
}

export default RecenterPin;
